import React, { FC, useCallback } from 'react';

import { ComponentDetailsPopup } from 'src/apps/wfa/components/component-details-popup/ComponentDetailsPopup';
import { ShowDetailsCellFormatter } from 'src/common/components/show-details-cell-formatter/ShowDetailsCellFormatter';
import { ProductType } from 'src/common/interfaces/Tenant';

interface IShowComponentDetailsCellFormatter {
	product: ProductType;
	runId: string;
	componentId: string;
	totalIssues: number;
	totalPages: number;
	infoTitle: string;
}

export const ShowComponentDetailsCellFormatter: FC<IShowComponentDetailsCellFormatter> = ({
	product,
	runId,
	componentId,
	totalIssues,
	totalPages,
	infoTitle
}) => {
	const renderPopup = useCallback(
		(closeModal: () => void) => (
			<ComponentDetailsPopup
				runId={runId}
				componentId={componentId}
				product={product}
				totalIssues={totalIssues}
				totalPages={totalPages}
				onClose={closeModal}
			/>
		),
		[componentId, product, runId, totalIssues, totalPages]
	);

	return (
		<ShowDetailsCellFormatter
			infoTitle={infoTitle}
			renderPopup={renderPopup}
			ariaLabel="Show Component Details"
		/>
	);
};
